import { types } from "../action-types";

const initialState = {
    loading: false,
    gig: [],
    success: false,
    error: false,
};
const createGigReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CREATE_GIG_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.CREATE_GIG_SUCCESS:
            return {
                ...state,
                loading: false,
                success:true,
                gig: action.payload,
                error: false,
            };
        case types.CREATE_GIG_FAILURE:
            return {
                ...state,
                loading: false,
                success:false,
                gig:[],
                error: true,
            };
        case types.CREATE_GIG_RESET:
            return{
                ...state,
                loading: false,
                success:false,
                gig:[],
                error: false,
            }
        default:
            return state;
    }
};
export default createGigReducer;